import type { Breaches } from '@api/ShiftGeneratorResultService';
import { useResultBreachesEntry } from '@stores/shiftGeneratorResultStore';
import { useParams } from 'react-router';
import { useMemo } from 'react';

const STAFFING_BREACH_RULES = [
    'WEEKLY_COVER_DEMANDS_MIN',
    'WEEKLY_COVER_DEMANDS_MAX',
    'WEEKLY_COVER_POS_DEMANDS',
    'TRAITS_EMPLOYEES',
];

const useResultBreaches = (): {
    breaches: Breaches['elements'] | undefined;
    isLoadingBreaches: boolean;
} => {
    const { departmentId, taskId } = useParams<{
        departmentId: string;
        taskId: string;
    }>();

    const { response, isLoading: isLoadingBreaches } = useResultBreachesEntry(
        departmentId,
        taskId,
        STAFFING_BREACH_RULES,
    );

    const breaches = useMemo(() => response?.elements, [response]);

    return { breaches, isLoadingBreaches };
};

export default useResultBreaches;
